import React from 'react';
import './Team.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import imgOne from '../../assets/about/team/1.png';
import imgTwo from '../../assets/about/team/2.png';
import imgThree from '../../assets/about/team/3.png';
import imgFour from '../../assets/about/team/4.png';

const Team = () => {

    const teams = [
        {
            'img': imgOne,
            'name': 'Joyce Nadir'
        },
        {
            'img': imgTwo,
            'name': 'César Nsingi'
        },
        {
            'img': imgThree,
            'name': 'Marco Bezerra'
        },
        {
            'img': imgFour,
            'name': 'Eliane Rodrigues'
        }
    ]


    return (
        <section className='team-section pt-100' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row">
                    <div className="col-lg-7">
                        <SectionTitle 
                            subTitle="Conheça nossa Equipe"
                            title="Conheça a Equipe de Dentistas da Odonto-Care"
                        />
                    </div>

                    <div className="col-lg-5">
                        <p className='pt-5'>Nossa equipe é formada por dentistas altamente qualificados e experientes, comprometidos em oferecer cuidados odontológicos de excelência.</p>
                    </div>
                </div>

                <div className="row">
                    {
                        teams.map (team => 
                            <div className="col-lg-3 col-sm-6">
                                <div className="team-card">
                                    <div className="team-img">
                                        <img src={team.img} alt="" />
                                    </div>
                                    <h3>{team.name}</h3>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </section>
    );
};

export default Team;